<template>
  <iframe
    ref="entregaIframe"
    style="border: none;"
    allow="midi; geolocation; microphone; camera; display-capture; encrypted-media;"
    sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation allow-downloads"
    frameborder="0"
    :src="`${baseUrl}?t=${new Date().getTime()}/#${path}?authorization=${authorization}`"
    width="100%"
    height="100%"
  />
</template>

<script>
import { mapActions } from 'vuex'
import {
  SESSION_HEADERS,
  SESSION_USER
} from 'utils/constants'
import Cookies from 'utils/Cookies'

export default {
  name: 'AccessIframe',
  props: {
    path: String
  },
  data () {
    return {
      namespace: 'Views.EntregaCall'
    }
  },
  computed: {
    authorization () {
      const sessionStr = localStorage.getItem(SESSION_HEADERS)
      const sessionObj = sessionStr ? JSON.parse(sessionStr) : {}
      return sessionObj.authorization
    },
    baseUrl () {
      return process.env.VUE_APP_ENTREGA_BASE || 'https://entrega.didiglobal.com'
    }
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    })
  },

  mounted () {
    window.addEventListener('message', (ev) => {
      if (ev.data && ev.data.msgType === 'etregaLoaded') {
        const user = JSON.parse(Cookies.get(SESSION_USER))
        let iframeRef = this.$refs['entregaIframe']
        iframeRef && iframeRef.contentWindow && iframeRef.contentWindow.postMessage(({
          msgType: 'parentUserInfo',
          user
        }), '*')
      }
    }, false)
    // TODO
  }
}
</script>
